/********
  * COMPONENT: USE THIS SERVICE TO MANAGE SYSTEM AUTHENTICATION - 
    #. MANAGE APPLICATION HTTP ERROR.
    #. .... .... .... ....
  * @AUTHOR: IMPRESSICO(fb/gshukla67).
  * DATE: 20/03/2018.
  * UPDATE: --/--/----.
*/
import { Injectable, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';

@Injectable()
export class ErrorService {

  public response;

  constructor(
    private _router: Router,
    private toasterService: ToasterService,
  ) { }

  public expiredSession(res?: any) {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('translateStr');
    localStorage.removeItem('firebaseInfo');
    localStorage.removeItem('authorizedRole');
    localStorage.removeItem('currentCustomer');
    localStorage.removeItem('notificationKeys');
    localStorage.removeItem('appConfiguration');
    localStorage.removeItem('PDNAccess');
    this._router.navigate(['/login']);
    if (res && res['message']) {
      this.toasterPop(res['name'], res['message']);
      //this.toasterService.clear();
    }
  }


  toasterPop(name, message) {
    //this.toasterService.clear();
    this.toasterService.pop('error', name, message);
    //this.toasterService.clear();
  }

}


// WEBPACK FOOTER //
// ./src/app/services/error.service.ts